import JshModule from '@core/scripts/helper/jsh-module';
import {createRoot} from 'react-dom/client';
import {NewsletterUnsubscribeForm} from '@service/scripts/components/contentful/NewsletterUnsubscribeForm.jsx';

const {moduleScope, config} = JshModule('service/service-page-newsletter-unsubscribe-form');

createRoot(moduleScope).render(<NewsletterUnsubscribeForm cdaEntry={config.model} />);
